// components
import AgentControl from '@/modules/Sandbox/components/AgentControl';
import UserControl from '@/modules/Sandbox/components/UserControl';

interface HeaderProps {
    agentId?: string;
    isFetching?: boolean;
}

const Header = ({ agentId, isFetching }: HeaderProps) => {
    return (
        <header className="flex flex-col gap-2 p-2 shadow-sm">
            <AgentControl agentId={agentId} isFetching={isFetching} />
            <UserControl />
        </header>
    );
};

export default Header;
